import React from 'react'
import Button from '../../DMGComponents/Button'
import Spinner from '../Spinner'
import Break from '../../DMGComponents/Break'
import AreaLogs from '../AreaLogs'
import { getAdminAreas, deleteAdminArea } from '../../fetchData'
import toast, { Toaster } from 'react-hot-toast'

class AdminAreas extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            areas: [],
            isLoading: false,
            selectedArea: null,
        }
        this.logsRef = React.createRef()
    }

    componentDidMount() {
        this.loadAreas()
    }

    loadAreas = () => {
        this.setState({ isLoading: true })
        getAdminAreas().then(res => {
            this.setState({ areas: res || [], isLoading: false })
        }).catch(() => {
            toast.error('Error loading areas.')
            this.setState({ isLoading: false })
        })
    }

    handleDelete = (area) => {
        if (!window.confirm(`Delete area "${area.name}"? This cannot be undone.`)) return
        deleteAdminArea(area.id).then(() => {
            this.setState(prev => ({ areas: prev.areas.filter(a => a.id !== area.id) }))
            toast.success(`Area "${area.name}" deleted.`)
        }).catch(() => {
            toast.error('Error deleting area.')
        })
    }

    handleShowLogs = (area) => {
        this.setState({ selectedArea: area }, () => {
            if (this.logsRef.current) {
                this.logsRef.current.scrollIntoView({ behavior: 'smooth' })
            }
        })
    }

    formatStatus = (status) => {
        switch (status) {
            case 0: return 'Active'
            case 1: return 'Released'
            default: return status
        }
    }

    render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <Toaster />
                <Break style={{ margin: '16px 0 12px 0' }}>Areas</Break>
                {this.state.isLoading && <div style={{ textAlign: 'center' }}><Spinner /></div>}
                {!this.state.isLoading && this.state.areas.length === 0 && <p>No areas found.</p>}
                {this.state.areas.length > 0 &&
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Name</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Description</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Status</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Files</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Expires</th>
                                <th style={{ textAlign: 'left', padding: '4px 8px' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.areas.map(area => (
                                <tr key={area.id} className="searchContent">
                                    <td style={{ padding: '4px 8px' }}>{area.name} (#{area.id})</td>
                                    <td style={{ padding: '4px 8px' }}>{area.description}</td>
                                    <td style={{ padding: '4px 8px' }}>{this.formatStatus(area.status)}</td>
                                    <td style={{ padding: '4px 8px' }}>{area.fileCount}</td>
                                    <td style={{ padding: '4px 8px' }}>
                                        {area.expirationDateUnixMs
                                            ? new Date(area.expirationDateUnixMs).toLocaleDateString()
                                            : '—'}
                                    </td>
                                    <td style={{ padding: '4px 8px' }}>
                                        <Button type="hover-bottom-left" onClick={() => this.handleShowLogs(area)}>Logs</Button>
                                        {' '}
                                        <Button type="hover-bottom-left" onClick={() => this.handleDelete(area)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                }
                {this.state.selectedArea &&
                    <div ref={this.logsRef} style={{ marginTop: '24px' }}>
                        <hr />
                        <AreaLogs area={this.state.selectedArea} isApprovalMode={false} autoLoad={true} />
                    </div>
                }
            </div>
        )
    }
}

export default AdminAreas
